import React from 'react';
import { Faqs } from '..';
import { MinusCircleOutlined, PlusCircleOutlined } from '@/components/Common/Icons';
import { FAQType } from '@/shared/types/subscription';
import cN from 'classnames';
import './index.less';

const ExpandIcon = () => <PlusCircleOutlined color="#A1A1A1" className="answer-display-toggler" />;
const CollapseIcon = () => <MinusCircleOutlined color="#A1A1A1" className="answer-display-toggler" />;

interface IProps {
  faq: FAQType[];
  className?: string;
}

const FAQContainer = ({ faq, className }: IProps) => {
  return (
    <div id="faq-container" className={cN('faq-container', className)}>
      <h2>Frequently asked questions</h2>
      <Faqs faqs={faq} CollapseIcon={CollapseIcon} ExpandIcon={ExpandIcon} />
    </div>
  );
};

export default FAQContainer;
